import React from "react";

import { Wrapper } from "./style";

export default props => {
  return <Wrapper transition={props.transition}>{props.title ? props.title : 'View more'}</Wrapper>;
};
